import z from "zod";

import { type ErrorDetails, RemiHttpCode } from "./remi-app";

const rdclIntegrationErrorTypeValues = [
  "TEST_ERROR",
  "WEBHOOK_HEADER_MISSING",
  "WEBHOOK_SIGNATURE_INVALID",
  "WEBHOOK_TIMESTAMP_STALE",
  "ZIP_EXTRACTION_REFUSED",
] as const;
const rdclIntegrationErrorTypeSchema = z.enum(rdclIntegrationErrorTypeValues);
const RdclIntegrationErrorType = rdclIntegrationErrorTypeSchema.enum;
type RdclIntegrationErrorType = z.infer<typeof rdclIntegrationErrorTypeSchema>;

export type RdclIntegrationErrors =
  | {
      errorType: typeof RdclIntegrationErrorType.ZIP_EXTRACTION_REFUSED;
      data: { archivePath: string; limit: string; observed: number; allowed: number };
    }
  | {
      errorType: typeof RdclIntegrationErrorType.TEST_ERROR;
      data: undefined;
    }
  | {
      errorType: typeof RdclIntegrationErrorType.WEBHOOK_HEADER_MISSING;
      data: { header: string };
    }
  | {
      errorType: typeof RdclIntegrationErrorType.WEBHOOK_SIGNATURE_INVALID;
      data: undefined;
    }
  | {
      errorType: typeof RdclIntegrationErrorType.WEBHOOK_TIMESTAMP_STALE;
      data: undefined;
    };

export const rdclIntegrationErrorDetails: Record<RdclIntegrationErrorType, ErrorDetails> = {
  [RdclIntegrationErrorType.TEST_ERROR]: {
    sentryDescription: "Test error for verifying error handling",
    remiHttpCode: RemiHttpCode.INTERNAL_SERVER_ERROR,
  },
  [RdclIntegrationErrorType.WEBHOOK_HEADER_MISSING]: {
    sentryDescription: "Required Svix webhook header is missing",
    remiHttpCode: RemiHttpCode.BAD_REQUEST,
  },
  [RdclIntegrationErrorType.WEBHOOK_SIGNATURE_INVALID]: {
    sentryDescription: "Svix webhook signature verification failed",
    remiHttpCode: RemiHttpCode.UNAUTHORIZED,
  },
  [RdclIntegrationErrorType.WEBHOOK_TIMESTAMP_STALE]: {
    sentryDescription: "Svix webhook rejected: timestamp outside the tolerance window (stale or replayed delivery)",
    remiHttpCode: RemiHttpCode.UNAUTHORIZED,
  },
  [RdclIntegrationErrorType.ZIP_EXTRACTION_REFUSED]: {
    sentryDescription:
      "RDCL deliverable archive breached a zip-extraction safety limit and was left unexpanded — the individual files never reached Remi",
    remiHttpCode: RemiHttpCode.INTERNAL_SERVER_ERROR,
  },
};
